var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.95 10.9998C19.449 16.0528 15.185 19.9998 10 19.9998C4.477 19.9998 0 15.5228 0 9.99983C0 4.81483 3.947 0.550828 9 0.0498281V2.06183C6.98271 2.31851 5.13885 3.3337 3.84319 4.90105C2.54752 6.4684 1.89728 8.47029 2.02462 10.4999C2.15196 12.5294 3.04733 14.4343 4.52874 15.8274C6.01016 17.2206 7.96645 17.9973 10 17.9998C11.9486 17.9998 13.8302 17.2886 15.2917 15.9998C16.7533 14.711 17.6942 12.9331 17.938 10.9998H19.951H19.95ZM19.95 8.99983H17.938C17.7154 7.23743 16.9129 5.59916 15.6568 4.34306C14.4007 3.08696 12.7624 2.28441 11 2.06183V0.0488281C13.2951 0.280064 15.4398 1.29743 17.0709 2.92865C18.7019 4.55986 19.719 6.70466 19.95 8.99983Z",
    fill: "#697077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.3e2249079b2dcab195292ef30e29fd21.svg";
export { ForwardRef as ReactComponent };